import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api'

function initialState() {
    return {
        film_genre: [],
        film_media: [],
        film_rights: [],
        territories: [],
        languages: [],
        film:[],
        film_type:[],
        film_format:[],
        media_random:[],
        film_random:[],
        film_artist:[]

    };
}

const state = initialState();

// actions

const actions = {

    async listAll(context) {
        var response = await API.tag.listAll();
        for (var key in response.tags) {
            if (response.tags.hasOwnProperty(key)) {
                context.commit('set_list', {
                    tags: response.tags[key],
                    tag_type: key
                });
            }
        }
        return response;
    },

    async list(context,payload) {
        var response = await API.tag.list(payload)
        context.commit('set_list', {
            tags: response.tags,
            tag_type: payload.tag_type
        })
        return response;
    },

    async getAssignedTags(context,payload) {
        var response = await API.tag.getTags(payload)
        return response;
    },

    async syncTag(context,payload) {
        var response = await API.tag.syncTag(payload)
        return response;
    },

}

// getters
const getters = {
    getField,
    getTag: (state) => (id, type) => {
        var tag =  state[type].find(tag => {
            return tag.id == id
        });
        return tag;
    },
    getTagsFromIds:(state, getters) => (ids, tag_type) => {
        var tags = []
        ids.forEach(tag_id => {
            var tag = getters['getTag'] (tag_id,tag_type)
            if(tag) tags.push(tag)
        });
        return tags
    }
};

// mutations
const mutations = {
    updateField,
    set_list(state,payload) {
        state[payload.tag_type] = payload.tags
    },

    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
            state[key] = s[key];
        });
    },

}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
